export default "__VITE_ASSET__ZDYlxRco__"